module.exports = "dist/images/[1]-[2]-[3].4e4682d.jpg";